import React from 'react';
import Slider from 'slider';
import _HighlightPromotionContainer from './_HighlightPromotionContainer.scss';
import {Promotions} from 'api';
import {LoadingPage} from 'components/loading-page';
import {UploadImage} from 'components/UI/Image';
import {Link, withRouter} from 'react-router-dom';

class HighlightPromotionContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit
      }
    };
    Promotions.actions.all.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    const settings = {
      className: 'slider variable-width custom-react-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 651,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 551,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      <section className='center highlight-promotion-container'>
        <h2 className='hinghlight-title'>
          <span className='red-title'>KHUYẾN MÃI&nbsp;NỔI BẬT</span>
        </h2>
        <Slider {...settings}>
          {this.state.data.map((item, i) => {
            return (
              <div className='hinghlight-item'>
                <Link className='item-link' to={item.link} target="_blank">
                  <UploadImage transform="crop" type="PROMOTION" width="270" height="300" image={item.image}/>
                </Link>
              </div>
            );
          })
}
        </Slider>
      </section>
    );
  }
}

export default withRouter(HighlightPromotionContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightPromotionContainer.jsx